const coursesData = [
    {
        id: "1",
        coursesName: "English Language",
        image: require("../../assets/images/english-language.jpg"),
        coursesClasses: [
            {
                id: "1",
                coursesClassesTitle: "First Semester",
                semesterUnits: [
                    {
                        id: "1",
                        semesterUnitsName: "Unit One",
                        lessonName: [
                            {
                                id: "1",
                                classesName: "Lesson One",
                                questions: [
                                    {
                                        questionId: "1",
                                        questionsTitle: "Questions Number 1",
                                        answers: [
                                            "1",
                                            "2",
                                            "3",
                                            "4",
                                        ],
                                        passAnswers: "3"
                                    },
                                    {
                                        questionId: "2",
                                        questionsTitle: "Questions Number 2",
                                        answers: [
                                            "1",
                                            "2",
                                            "3",
                                            "4",
                                        ],
                                        passAnswers: "3"
                                    },
                                    {
                                        questionId: "3",
                                        questionsTitle: "Questions Number 3",
                                        answers: [
                                            "1",
                                            "2",
                                            "3",
                                            "4",
                                        ],
                                        passAnswers: "3"
                                    },

                                ]
                            },
                            {
                                id: "2",
                                classesName: "Lesson Two",
                                questions: [
                                    {
                                        questionId: "2",
                                        questionsTitle: "Questions Number Two",
                                        answers: [
                                            "1",
                                            "2",
                                            "3",
                                            "4",
                                        ],
                                        passAnswers: "2"
                                    }

                                ]
                            },
                        ]
                    },
                    {
                        id: "1",
                        semesterUnitsName: "Unit One2",
                        lessonName: [
                            {
                                id: "1",
                                classesName: "Lesson One2",
                                questions: [
                                    {
                                        questionId: "1",
                                        questionsTitle: "Questions Number One",
                                        answers: [
                                            "1",
                                            "2",
                                            "3",
                                            "4",
                                        ],
                                        passAnswers: "3"
                                    }

                                ]
                            },
                        ]
                    },
                ]
            },
            {
                id: "2",
                coursesClassesTitle: "Second Semester",
                semesterUnits: [
                    {
                        id: "1",
                        semesterUnitsName: "Unit Two",
                        lessonName: [
                            {
                                id: "1",
                                classesName: "Lesson Three",
                                questions: [
                                    {
                                        questionId: "1",
                                        questionsTitle: "Questions Number Three",
                                        answers: [
                                            "1",
                                            "2",
                                            "3",
                                            "4",
                                        ],
                                        passAnswers: "1"
                                    }

                                ]
                            },
                            {
                                id: "2",
                                classesName: "Lesson Four",
                                questions: [
                                    {
                                        questionId: "2",
                                        questionsTitle: "Questions Number Four",
                                        answers: [
                                            "1",
                                            "2",
                                            "3",
                                            "4",
                                        ],
                                        passAnswers: "2"
                                    }

                                ]
                            },
                        ]
                    }
                ]
            }
        ]
    }
]

export default coursesData;